<template>
  <h2>Messen</h2>
  <mass-create-edit-modal :pass-in-mass="null" trigger-class="btn-success" trigger-icon="create"
                          trigger-text="Neue Messe anlegen"></mass-create-edit-modal>
  <mass-bulk-create-modal trigger-class="btn-success" trigger-icon="create"
                          trigger-text="Mehrere Messe anlegen"></mass-bulk-create-modal>
  <router-link :to="{name: 'Messen Import'}" class="btn btn-success"><em class="align-middle material-icons">cloud_download</em>
    Messen aus KaPlan importieren
  </router-link>

  <DataTable :cols="[
                    {title: 'Datum & Uhrzeit', key: 'datetime', type: 'datetime', sortable: true},
                    {title: 'Weihrauch', key: 'incense', type: 'checkbox'},
                    {title: 'Anz. Messdiener', key: 'requiredAltarServers', type: 'number'},
                    {title: 'Anz. Leiter', key: 'requiredLeaders', type: 'number'},
                    {title: 'Anmerkung', key: 'annotation', type: 'text'},
                    {title: 'Uhrzeit dick?', key: 'boldTime', type: 'checkbox'},
                    {type: 'inject', key: 'edit'},
                    {type: 'inject', key: 'delete'},
               ]"
             :data="massStore.sortedData"
             :store="massStore" caption="Liste aller Messen" @sort="col_key => this.massStore.sort(col_key)"
             @update="el => this.massStore.updateItem(el)">

    <template #edit="{el}">
      <mass-create-edit-modal :pass-in-mass="el" trigger-class="btn-warning" trigger-icon="create"
                              trigger-text=""></mass-create-edit-modal>
    </template>
    <template #delete="{el}">
      <button class="btn btn-danger"
              @click="this.massStore.deleteItem(el, true, `die Messe am ${new Date(el.datetime).toLocaleDateString()} um ${new Date(el.datetime).toLocaleTimeString()} Uhr`)">
        <em class="align-middle material-icons">delete</em>
      </button>
    </template>
  </DataTable>
</template>

<script>
import MassCreateEditModal from "@/components/MassCreateEditModal";
import MassBulkCreateModal from "@/components/MassBulkCreateModal";
import {useMassStore} from "@/stores/mass";
import DataTable from "@/components/DataTable.vue";

export default {
  name: "VueMasses",
  components: {DataTable, MassBulkCreateModal, MassCreateEditModal},
  created() {
    this.massStore.getData();
  },
  setup() {
    const massStore = useMassStore();
    return {massStore};
  }
}
</script>
